import { DropdownItem } from '@marqvision/mds-v2';
import {
  MarqBrandEnumsListingMonitoringStatusEnum,
  MarqCommonEnumsReportableReasonEnum,
  MarqCommonEnumsSortedOrderEnum,
  MonitoringFilterProtocolResponse,
  MonitoringFilterProtocolResponseFilterItem,
} from '~/swagger/data-contracts';
import { DropDown, SortValueEnum } from '~/components/Filters/@types';
import { MarketplaceListingsRouteEnum, SocialMediaListingsRouteEnum } from '~/router/@types';

export const parseMarqCommonEnumsSortedOrderEnum = (order?: SortValueEnum): MarqCommonEnumsSortedOrderEnum => {
  switch (order) {
    case SortValueEnum.Asc:
      return MarqCommonEnumsSortedOrderEnum.Asc;
    case SortValueEnum.Desc:
      return MarqCommonEnumsSortedOrderEnum.Desc;
    default:
      return MarqCommonEnumsSortedOrderEnum.Asc;
  }
};

// todo-@elie: useInfiniteQuery 내에서 처리하지 못해 mergePages 를 뷰에서 사용하고 있음, 방법을 찾으면 제거필요.
export const mergePages = <T>(filterList?: DropDown<T>[]): DropDown<T> => {
  if (!filterList) return { count: 0, list: [] };

  return filterList.reduce(
    (acc, page, currentIndex) => {
      return {
        count: currentIndex === 0 ? page.count : acc.count,
        list: [...acc.list, ...page.list],
      };
    },
    { count: 0, list: [] }
  );
};

export const mergePagesV2Dropdown = (filterList?: DropDown[]) => {
  if (!filterList) return { count: 0, list: [] };

  return filterList.reduce(
    (acc, page, currentIndex) => {
      return {
        count: currentIndex === 0 ? page.count : acc.count,
        list: [...acc.list, ...page.list],
      };
    },
    { count: 0, list: [] }
  );
};

export const parseDropDownItem = <T>(data?: MonitoringFilterProtocolResponseFilterItem): DropdownItem<T> => {
  if (!data) return { value: '' as T, label: '' };

  const { id, text, count, list, image_url, ...rest } = data;

  return {
    ...rest,
    value: id as T,
    label: text,
    subLabel: typeof count === 'number' ? { label: count.toLocaleString(), position: 'bracket' } : undefined,
    imgUrl: image_url ?? undefined,
    children: list
      ? list.map((item) => {
          return parseDropDownItem<T>(item);
        })
      : undefined,
  };
};

export const parseDropDown = <T = number>(data?: MonitoringFilterProtocolResponse): DropDown<T> => {
  if (!data) return { count: 0, list: [] as DropdownItem<T>[] };

  const { count, search_after, filter_display, list } = data;

  return {
    count: count || 0,
    search_after,
    filter_display,
    list: list.map((item) => parseDropDownItem<T>(item)),
  };
};

export const parseMarqBrandEnumsListingMonitoringStatusEnum = (
  status: string
): MarqBrandEnumsListingMonitoringStatusEnum => {
  switch (status) {
    case MarketplaceListingsRouteEnum.Dismissed:
      return MarqBrandEnumsListingMonitoringStatusEnum.Dismissed;
    case SocialMediaListingsRouteEnum.Dismissed:
      return MarqBrandEnumsListingMonitoringStatusEnum.Dismissed;
    default:
      return status as MarqBrandEnumsListingMonitoringStatusEnum;
  }
};
export const parseMarqCommonEnumsReportableReasonEnumList = (
  reasons?: string[]
): MarqCommonEnumsReportableReasonEnum[] => {
  if (!reasons) return [];

  return reasons.reduce<MarqCommonEnumsReportableReasonEnum[]>((acc, cur) => {
    if (Object.values(MarqCommonEnumsReportableReasonEnum).includes(cur as MarqCommonEnumsReportableReasonEnum)) {
      return acc.concat([cur as MarqCommonEnumsReportableReasonEnum]);
    } else {
      return acc;
    }
  }, []);
};

/**
 * why NO_TAG_VALUE = -2?
 * -> 참고: https://marqvision.atlassian.net/browse/PROD-13463?focusedCommentId=38149
 */
export const NO_TAG_VALUE = -2;
export const parseCustomTagFilterDropdown = (data: MonitoringFilterProtocolResponse) => {
  const parsed = parseDropDown(data);

  const dataWithNoTagOption =
    parsed.count > 0
      ? [
          {
            value: NO_TAG_VALUE,
            label: 'No Tags',
          },
          {
            label: 'With tags',
            children: parsed.list,
          },
        ]
      : [];

  return {
    count: parsed.count,
    search_after: parsed.search_after,
    list: dataWithNoTagOption,
  };
};
/**
 * custom tag는 리스트에서 자유롭게 적용, 삭제 하는게 가능하기 때문에
 * 현재 보고 있는 리스트에 없는 custom tag 아이디가 있는 시나리오가 쉽게 발생하며,
 * 이러한 시나리오를 방지하기 위해 한차례 거르는 작업을 한다.
 */
export const hasCustomTagInAllTagOptions = (allTagOptions: DropdownItem<number>[], selectedCustomTagIds: number[]) => {
  return allTagOptions.some((item) => {
    if (item.children) {
      return item.children.some((child) => selectedCustomTagIds.includes(child.value as number));
    } else {
      return selectedCustomTagIds.includes(item.value as number);
    }
  });
};
